// @flow

import fetchIncludeCredentials from "./utils/fetchIncludeCredentials";
import { isCD } from "./utils/envDetection";
import { getCustUrl } from "./../utils/cust";

const fetchInternal = async (requestType, params = {}, options) => {
    try {
        const custUrl = getCustUrl();

        const fullParams = {
            action: "rest",
            request: requestType,
            go: custUrl,
            password: "null",
            blogpassword: "bypass",
            ...params
        };

        let url;
        let response;
        if (isCD) {
            switch (requestType) {
                case "cust":
                case "diaries":
                case "imagemonths":
                case "messages":
                case "stops":
                    response = await import(`/Users/georgeb/crawl/temp/data/${requestType}`);
                    break;
                case "diary":
                    response = await import(`/Users/georgeb/crawl/temp/data/blog-${params.diaryId}`);
                    break;
                case "images":
                    response = await import(`/Users/georgeb/crawl/temp/data/images-${
                        params.startDate
                    }-${params.endDate}`);
                    break;
                default:
                    response = { found: false };
            }
        } else {
            url = "https://www.getjealous.com/blog.php?";

            Object.keys(fullParams).forEach(key => {
                url += `&${key}=${fullParams[key]}`;
            });

            response = await fetchIncludeCredentials(url, requestType, options);
        }
        return response;
    } catch (err) {
        err.message = `Unable to retrieve ${requestType}, ${JSON.stringify(params)}: ${
            err.message
        }`;
        throw err;
    }
};

export const postRest = async (requestType, params = {}, options) => {
    console.log(`Posting ${requestType}, ${JSON.stringify(params)}`);
    return fetchInternal(requestType, params, { ...options, requestType: "POST" });
};

export const fetchRest = async (requestType, params = {}, options) => {
    console.log(`Loading ${requestType}, ${JSON.stringify(params)}`);
    return fetchInternal(requestType, params, options);
};



// WEBPACK FOOTER //
// ./src/rest/rest.js